/* eslint-disable */
// @ts-nocheck
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useConfig } from '../../../config/useConfig';
import { useAppSelector } from '../../../store/hooks';
import { deleteRoomScene, setRoomScenes } from '../../../store/roomScene.slice';
import { store } from '../../../store/store';
import { setLoader, setOpenMsg } from '../../../store/user.slice';
import { errorMessage } from '../../../utils';

export const useRoomScene = () => {
  const { apiInstance } = useConfig();
  const dispatch = useDispatch();

  const getRoomScene = useCallback(async () => {
    dispatch(setLoader(true));
    const {
      user: { userData },
    } = store.getState();
    const { user, token } = userData || {};
    const userId = user?._id;
    try {
      const { data } = await apiInstance.post(
        '/user/read-all-user-scenes',
        {
          userId,
        },
        {
          headers: {
            authorization: 'Bearer ' + token,
          },
        },
      );
      if (data?.status) {
        dispatch(setRoomScenes(data.userScenesObjArray));
        // dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const saveRoomScene = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    const {
      user: { userData },
    } = store.getState();

    const { user, token } = userData || {};
    const userId = user?._id;
    const payloadData = { ...payload, userId };

    const formData = new FormData();
    for (let key in payloadData) {
      if (payloadData.hasOwnProperty(key)) {
        if (key == 'file') {
          formData.append(key, payloadData[key], payload.roomName + '.png');
        } else {
          formData.append(key, payloadData[key]);
        }
      }
    }

    try {
      const { data } = await apiInstance.post('/user/save-user-scene', formData, {
        headers: {
          authorization: 'Bearer ' + token,
          'Content-type': 'multipart/form-data;',
        },
      });
      if (data?.status) {
        // dispatch(setRoomScenes(data.userScenesObjArray));
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        callBack('Unsave Scene', data?.userScene?._id);
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const deleteRoomSceneById = useCallback(async (userSceneId, callBack) => {
    dispatch(setLoader(true));
    const {
      user: { userData },
    } = store.getState();
    const { user, token } = userData || {};
    const userId = user?._id;
    try {
      const { data } = await apiInstance.post(
        '/user/remove-user-scene-by-id',
        {
          userId,
          userSceneId,
        },
        {
          headers: {
            authorization: 'Bearer ' + token,
          },
        },
      );
      if (data?.status) {
        dispatch(deleteRoomScene(userSceneId));
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        if (callBack) {
          callBack('Save Scene', null);
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  return { getRoomScene, saveRoomScene, deleteRoomSceneById };
};
